export default __webpack_public_path__ + "static/media/QV_Points_4.a988ba61.png";